<template>
	<div class="whitelist mt-5">
		<div class="row">
			<div class="col-8 offset-2 mt-5">

				<div class="card">
					<div class="card-body text-center">
						<h1 class="mt-4">Whitelist Entry Confirmation</h1>

						<p class="mt-4">To enable access to the AlphaBatem land whitelist we require a Phantom wallet address to be
							registered.</p>

						<p class="mt-4">Fill in the form below to complete your whitelist entry along with the code you received on
							your
							confirmation
							email.</p>

						<WhitelistForm class="mt-5 col-8 offset-2 text-left"></WhitelistForm>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import WhitelistForm from "../components/whitelist/WhitelistForm";

export default {
	name: "Whitelist",
	components: {WhitelistForm}
}
</script>

<style scoped>
.card, .card-body {
	background: white;
	color: black;
}
</style>